import axios from 'axios'
import baseUrl from '../Config/BaseUrls'

class CssApiClient {
  static userInfo = null

  static setUserInfo (userInfo) {
    this.userInfo = userInfo
  }

  static async getAccessToken (oktaAuth) {
    if (!oktaAuth) {
      throw new Error('OktaAuth instance is required')
    }

    const token = await oktaAuth.tokenManager.get('accessToken')
    if (!token) {
      throw new Error('User is not authenticated')
    }
    return token.accessToken
  }

  static async axiosInstance (oktaAuth, isAuthorization = true) {
    const headers = { 'Content-Type': 'application/json' }

    if (isAuthorization && oktaAuth) {
      const token = await CssApiClient.getAccessToken(oktaAuth)
      headers['Authorization'] = `Bearer ${token}`
    }

    return axios.create({
      baseURL: baseUrl,
      headers
    })
  }

  static async getClientIp () {
    try {
      const res = await fetch('https://api.ipify.org?format=json')
      const data = await res.json()
      return data.ip
    } catch {
      return 'UNKNOWN'
    }
  }

  static async handleRequest (fn, payload, config) {
    try {
      const response = await fn(payload, config)
      return response.data
    } catch (error) {
      if (error.response && error.response.status === 500) {
        const ipAddress = await CssApiClient.getClientIp()
        const userInfo = CssApiClient.userInfo

        await CssApiClient.postLog({
          userId: userInfo?.sub || 'UNKNOWN',
          email: userInfo?.email || 'UNKNOWN',
          name: userInfo?.name || 'UNKNOWN',
          job_profile: userInfo?.job_profile || 'UNKNOWN',
          userAction: error.response?.data?.userAction || 'API_CALL',
          errorMessage: error.response?.data?.error || error.message,
          statusCode: error.response.status,
          ipAddress
        })
      }
      throw error
    }
  }

  static async fileDownloadRequest (oktaAuth, payload = {}, config = {}) {
    const axiosInst = await CssApiClient.axiosInstance(oktaAuth, true)
    return CssApiClient.handleRequest(
      (p, c) => axiosInst.post('/file-download-request', p, c),
      payload,
      config
    )
  }

  static async fileDownloadStatus (oktaAuth, payload = {}, config = {}) {
    const axiosInst = await CssApiClient.axiosInstance(oktaAuth, true)
    return CssApiClient.handleRequest(
      (p, c) => axiosInst.post('/file-download-status', p, c),
      payload,
      config
    )
  }

  static async postDropdown (oktaAuth, payload, config = {}) {
    const axiosInst = await CssApiClient.axiosInstance(oktaAuth, true)
    return CssApiClient.handleRequest(
      (p, c) => axiosInst.post('/css-workbench-dropdown', p, c),
      payload,
      config
    )
  }

  static async postCSSData (oktaAuth, payload, config = {}) {
    const axiosInst = await CssApiClient.axiosInstance(oktaAuth, true)
    return CssApiClient.handleRequest(
      (p, c) => axiosInst.post('/css-workbench-data', p, c),
      payload,
      config
    )
  }

  static async postCaregivers (oktaAuth, payload, config = {}) {
    const axiosInst = await CssApiClient.axiosInstance(oktaAuth, true)
    return CssApiClient.handleRequest(
      (p, c) => axiosInst.post('/caregivers', p, c),
      payload,
      config
    )
  }

  static async postLog (payload, config = {}) {
    const axiosInst = await CssApiClient.axiosInstance({}, false)
    const response = await axiosInst.post('/logs', payload, config)
    return response.data
  }

  static async postSchedulingRequest (oktaAuth, payload, config = {}) {
    const axiosInst = await CssApiClient.axiosInstance(oktaAuth, true)
    return CssApiClient.handleRequest(
      (p, c) => axiosInst.post('/callout-caregiver-list', p, c),
      payload,
      config
    )
  }
}

export default CssApiClient
